import { useEffect, useState } from "react";
import { Container, Spinner } from "reactstrap";
import ChatBot from "../helpers/chatbotNewWidget";
import fetchUserDetailsFromParamsOrCookie from "../helpers/token-util";
import { KEY_CHAIN } from "../constants";
import TrackSnowPlowEvents from "../helpers/trackSnowPlowEvents";
import useTaskDeviceBridge from "@docsapp/native-wizard-sa/src/lib/useTaskDeviceBridge";
import { getCookie } from "../helpers/utils";
import { TokenType } from "@docsapp/native-wizard-sa/src/lib/TaskDeviceBridge";
import { MIA_CHATBOT_URL } from "../helpers/chatbotNavigation";
import { fetchChatbotConfiguration } from "../helpers/chatbotConfig";

function UpdatedWidget() {
  const [userDetailsFetched, setUserDetailsFetched] = useState(false);
  const [userDetails, setUserDetails] = useState(null);
  const [longToken, setLongToken] = useState("");
  const [shortToken, setShortToken] = useState("");

  const taskDeviceBridge = useTaskDeviceBridge();

  const redirectToChatbot = () => {
    window.location.assign(MIA_CHATBOT_URL);
  };

  // Handles a successfully authenticated user: if MIA chatbot is enabled for
  // them, redirect to the MIA chatbot page; otherwise fall back to rendering
  // the legacy ChatBot widget in place.
  const handleAuthenticatedUser = async (resp) => {
    setUserDetailsFetched(true);
    setUserDetails(resp.userInfo);
    setLongToken(resp.longToken);
    setShortToken(resp.shortToken);
    TrackSnowPlowEvents(resp.userInfo);

    const chatbotConfig = await fetchChatbotConfiguration(
      resp.userInfo.pmEntityID,
      resp.shortToken,
    );

    if (chatbotConfig.shouldEnableChatbot) {
      redirectToChatbot();
      return;
    }
    ;
  };

  const fetchUserDetailsWithTokenRefresh = async () => {
    try {
      // First attempt with existing tokens
      const resp = await fetchUserDetailsFromParamsOrCookie();

      if (resp && resp.userInfo) {
        await handleAuthenticatedUser(resp);
        return;
      }

      // If no user details, try native token refresh (only on Android/iOS)
      if (!resp || !resp.userInfo) {
        const deviceOs = getCookie("platform");
        const isNativePlatform =
          deviceOs === "Android_mv" || deviceOs === "iOS_mv";

        if (isNativePlatform) {
          try {
            // Call native token refresh - this just triggers refresh, doesn't return tokens

            const res = await taskDeviceBridge.fetchNewToken(
              TokenType.MARKETPLACE_SHORT_TOKEN,
            );

            const tokenData = typeof res === "string" ? JSON.parse(res) : res;
            //We store the short token or mbServerToken in the redirect cookie, then identify the token type and use it.
            const token = tokenData?.redirect || tokenData?.mbServerToken;
            if (token) {
              document.cookie = `${KEY_CHAIN.REDIRECT}=${token};path=/`;
            } else {
              await new Promise((resolve) => setTimeout(resolve, 30));
            }

            // After successful refresh, get tokens from cookies again
            const refreshedResp = await fetchUserDetailsFromParamsOrCookie();

            if (refreshedResp && refreshedResp.userInfo) {
              await handleAuthenticatedUser(refreshedResp);
              return;
            } else {
              redirectToChatbot();
              return;
            }
          } catch (refreshError) {
            redirectToChatbot();
            return;
          }
        } else {
          redirectToChatbot();
          return;
        }
      }

      // No tokens available or other error, set as failed
      setUserDetailsFetched(true);
      setUserDetails(null);
      ;
      TrackSnowPlowEvents(null);
    } catch (error) {
      setUserDetailsFetched(true);
      setUserDetails(null);
      ;
      TrackSnowPlowEvents(null);
    }
  };

  useEffect(() => {
    fetchUserDetailsWithTokenRefresh();

    // Detect embed mode
    const urlParams = new URLSearchParams(window.location.search);
    const isEmbedMode = urlParams.get("embed") === "true";

    if (isEmbedMode) {
      document.body.classList.add("embed-mode");
    }

    return () => {
      document.body.classList.remove("embed-mode");
    };
  }, []);

  return (
    <main role="main" aria-label="Customer Support Chat">
      <Container>
        <div>..</div> {/* Render dialog */}
        <section role="region" aria-label="Chat Widget">
          {userDetailsFetched && (
            <ChatBot
              userDetails={userDetails}
              longToken={longToken}
              shortToken={shortToken}
            />
          )}
        </section>
      </Container>
    </main>
  );
}
export default UpdatedWidget;
